export default {
  slider: {},
};
